import { SYN_API_URLS } from '@/constants/api';
import { axiosGet } from '@/utils/axios';
import _ from 'lodash';
import { FetchTokenPriceMapInput, FetchTokenPriceMapResponse, ITokenPrice } from './type';

export const getTokenPriceMap = async ({ chainId }: FetchTokenPriceMapInput): Promise<FetchTokenPriceMapResponse> => {
  const response = await axiosGet({
    url: SYN_API_URLS.GLOBAL.TOKEN_PRICE,
    config: { params: { chainId } },
  });

  const tokenPrices = (response?.data?.data as ITokenPrice[]) || [];
  const tokenPriceMap = _.keyBy(
    tokenPrices.map((price: ITokenPrice) => ({
      ...price,
      priceChangePercentage24h: Number(price.priceChangePercentage24H) / 100,
      current: price.currentPrice,
    })),
    'address',
  );

  return tokenPriceMap;
};
